/* global attachEvent */
// Close content
attachEvent('.image-card__close', 'click', (ev) => {
  const parentElem = ev.target.closest('.image-card');
  parentElem.classList.remove('is-open');
});
